import * as React from 'react';
export const boaSvg = React.forwardRef(function boaSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        d: 'M0 0h32v32H0z',
        fill: '#fff',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M12.923 12.209c.79.335 1.57.695 2.34 1.079a50.501 50.501 0 0 0-7.085 3.794A43.265 43.265 0 0 0 5.85 15.86a47.586 47.586 0 0 1 7.074-3.651m-2.921-1.11a39.08 39.08 0 0 0-7.326 3.38c.742.29 1.476.596 2.2.925a40.494 40.494 0 0 1 7.11-3.579 42.352 42.352 0 0 0-1.984-.726',
        fill: '#0067b1',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M18.243 12.102a41.378 41.378 0 0 0-6.217-2.619 40.61 40.61 0 0 0-2.236.764c2.2.7 4.34 1.587 6.4 2.649a47.56 47.56 0 0 1 2.053-.794m3.266-1.047a44.833 44.833 0 0 0-6.331-2.406 42.23 42.23 0 0 0-2.055.512c2.15.675 4.24 1.53 6.256 2.549a48.298 48.298 0 0 1 2.13-.655m5.244 1.895a53.896 53.896 0 0 0-14.308 7.839 51.73 51.73 0 0 1 3.186 2.287 57.23 57.23 0 0 1 13.567-8.638 47.59 47.59 0 0 0-2.445-1.488m-3.534-1.807c-5.342 1.52-10.365 3.973-14.894 7.203 1.02.54 2.023 1.116 3.004 1.73 4.438-3.305 9.363-5.878 14.616-7.575a45.996 45.996 0 0 0-2.726-1.358',
        fill: '#e31836',
      }),
    ),
  );
});
boaSvg.defaultProps = {
  height: '32',
  viewBox: '0 0 32 32',
  width: '32',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var boa = {
  category: 'brand',
  colorable: false,
  name: 'boa',
  svg: boaSvg,
};
